import React from 'react';
import ContactCell from '../CotactCell';

const ContactActionCell = ({
    anchorRef,
    open,
    setOpen,
    isMobile,
    buttonHandleClose,
    handlePopup,
    viewDetailBtn,
    handleCompleteTreatment,
    handleAttendedClick,
    handleAttendedFailedClick,
    handleAttendedPopup,
    handleSyncDentally,
    syncingLeadIds,
    minWidth = 200
}) => ({
    field: 'contact',
    headerName: 'Action',
    sortable: false,
    minWidth,
    align: 'center',
    renderCell: (params) => (
        <ContactCell
            row={params?.row}
            anchorRef={anchorRef}
            open={open}
            setOpen={setOpen}
            isMobile={isMobile}
            buttonHandleClose={buttonHandleClose}
            handlePopup={handlePopup}
            viewDetailBtn={viewDetailBtn}
            handleCompleteTreatment={handleCompleteTreatment}
            handleAttendedClick={handleAttendedClick}
            handleAttendedFailedClick={handleAttendedFailedClick}
            handleAttendedPopup={handleAttendedPopup}
            handleSyncDentally={handleSyncDentally}
            syncingLeadIds={syncingLeadIds}
        />
    ),
});

export default ContactActionCell;